import React from 'react';
import ConsultContainer from './ConsultContainer';
import ConsultSimulatorContainer from './ConsultSimulatorContainer';

const SkuCalculator = () => {
  return (
    <div>
      <h1>SKU Calculator</h1>
      <ConsultContainer />
      <h2>Consultation Simulator</h2>
      <ConsultSimulatorContainer />
    </div>
  );
};

export default SkuCalculator;
